export const sliderData = [{
    id: 1,
    image: './myimg/recep-tiryaki-1vC4ZwkJNdA-unsplash.jpg',
    header: 'COMBAT INVENTORY',
    description: "With packs worn into battle and tested by our nation's greatest heroes, you'll always be prepared with Mercury Tactical Gear."
},
{
    id: 2,
    image: './myimg/jan-abellan-Vf6Voxf-q80-unsplash.jpg',
    header: 'FIELD TESTED, BATTLE PROVEN',
    description: "Trusted Hostlers by Elite operators. Engineered to adapt to the world's toughest environment, our packs will hold up to any mission."
},
{
    id: 3,
    image: './myimg/hizir-kaya-ExxuYNsViC4-unsplash.jpg',
    header: 'Combat Ready Products',
    description: 'Designed by Concealed carriers for concealed carriers'
},
{
    id: 4,
    image: './myimg/hizir-kaya-0q90Mumo-xE-unsplash.jpg'
}]
